
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { GroupService } from './group.service';
import dayjs from 'dayjs';
import { Qalendar } from 'qalendar';
import { ToastFactory } from '@/utils/ToastFactory';
const groupService = new GroupService();

export default defineComponent({
  name: 'ListGroups',
  data() {
    return {
      event: null,

      alocations: [] as any,

      params:{ dateFinish:'', dateInit: '', page: 0, size: 100 },

      config: {
        locale: navigator.language,
        defaultMode: 'month',
        isSilent: true,
        showCurrentTime: true,
        week:{
          startsOn: 'sunday',
        },
        dayBoundaries: {
          start: 8,
          end: 23,
        },
        style: {
          FontFamily: 'Inter',
          colorSchemes: {
            group: {
              color: '#153c59',
              backgroundColor: '#DFEDFC',
              borderLeft: '4px solid #153c59',
            },
          }
        },
    },
    }
  },
  components: {
    Qalendar,
  },

  computed:{
    ...mapGetters({
      storeGroups: 'groups/getGroups',
    }),
  },

  methods: {
    openEvent(event: any){
      this.$router.push({ name: 'editGroup', params: { id: event } });
    },

    deleteGroup(id: any){
      groupService.deleteGroup(id).then(() => {
        this.getGroups();
        this.$toast.add(ToastFactory.success(this.$t("toast.sucessGroupDelete")));
      }).catch(() => {
        this.$toast.add(ToastFactory.error(this.$t("toast.errorGroupDelete")));
      })

    },

    confirmDelete(id: any){
            this.$confirm.require({
                header: this.$t('group.delete'),
                message: this.$t('group.confirmDelete'),
                accept: () => {
                    this.deleteGroup(id);
                },
                reject: () => {
                    console.log('reject');
                }
            });
    },

    getGroups(){
      groupService.getGroups(this.params).then(() => {
        const groups = this.storeGroups.content;

        const events: any[] = [];

        groups.forEach((group: any) => {
          const start = dayjs(group.createdDate);
          const end = dayjs(group.finishDate);
          const duration   = end.diff(start, 'days');

          for(let i = 0; i <= duration; i++){

            const date = dayjs(start).add(i, 'days');
            const dayOfWeek = date.day();
            const mapDays = group.calendarList[0].daysWeek.map((day: any) => day.day);
            
            
            if(mapDays.includes(dayOfWeek)){

              const day = date.format('YYYY-MM-DD');
              const checkIn = group.calendarList[0].checkIn;
              const checkOut = group.calendarList[0].checkOut;

              const start = day + " " + checkIn;
              const end = day + " " + checkOut;

              const event = {
                title: group.name,
                time: {
                  start: start.slice(0, -3),
                  end: end.slice(0, -3)
                },
                isEditable: true,
                disableDnD: ['month', 'week', 'day'],
                id: group.id,
                colorScheme: "group",
              }
              events.push(event);
              
            }
          }
        });
        this.alocations = events;
      });
    },

    getRange(event: any){
      const start = dayjs(event.start).format('YYYY-MM-DD');
      const end = dayjs(event.end).format('YYYY-MM-DD');

      this.params.dateInit = start;
      this.params.dateFinish = end;
      this.getGroups();
    },

    getCurrentMonth(){
      const start = dayjs().startOf('month').format('YYYY-MM-DD');
      const end = dayjs().endOf('month').format('YYYY-MM-DD');

      this.params.dateInit = start;
      this.params.dateFinish = end;
    },

  },

  mounted() {
    this.getCurrentMonth();
    this.getGroups();
  }

})
